import Vue from 'vue'
import api from '../libs/requestApi'

Vue.use(api)

if (Vue === undefined) {
	throw Error('Please, install VueJS')
}

if (Vue.api === undefined) {
	throw Error('Please, install requestApi library')
}

class Attachment {
	constructor(name, file) {
		this.name = name || ''
		this.file = this.constructor.addFile(file, this.name)
	}

	static addFile(file, name = 'image') {
		let formData = new FormData();
		formData.append('file', file, name);

		return formData
	}

	upload(objType, id, isRemove = 1) {
		this.file.append('obj_type', objType);
		this.file.append('obj_id', id);
		this.file.append('remove', !!isRemove);

		return Vue.api.post('attachment/upload', this.file)
	}

}

export default Attachment



// WEBPACK FOOTER //
// ./src/common/Attachment.js